import { LIFE, LONG_TERM_CARE } from '../FinancialPlan/Insurance/InsuranceConstants';
import { ASSUMPTIONS } from '../FinancialPlan/Explanations/ExplanationsConst';

export const INSURANCE_GOAL_TYPE = 'insurance';

// ViewId and WhatIfType are equivalent
export const RETIREMENT_GENERAL_AGES = 0;
export const RETIREMENT_GENERAL_EXPENSES = 1;
export const RETIREMENT_GENERAL_LIFE_EXPECTANCIES = 2;
export const RETIREMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 3;
export const RETIREMENT_DISTRIBUTIONS_DISTRIBUTIONS = 4;
export const RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_PRE = 5;
export const RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_POST = 6;
export const RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS = 7;
export const RETIREMENT_STRESS_TEST_INFLATION_CHANGES = 8;
export const RETIREMENT_STRESS_TEST_MARKET_DROPS = 9;
export const RETIREMENT_ROTH_CONVERSION = 10;

export const EMERGENCY_FUND_GENERAL_TARGET_AMOUNT = 300;
export const EMERGENCY_FUND_GENERAL_GOAL_YEAR = 301;

export const EDUCATION_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 102;
export const LARGE_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 203;
export const EMERGENCY_FUND_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 302;
export const HEALTH_CARE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 403;
export const HOME_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 1105;
export const DEBT_MANAGEMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS = 600;
export const DEBT_MANAGEMENT_STRATEGY_REPLAYMENT = 601;
export const DEBT_MANAGEMENT_REFINANCE = 602;

export const EDUCATION_ASSET_ALLOCATIONS_ASSET_ALLOCATION = 103;
export const LARGE_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION = 204;
export const HEALTH_CARE_ASSET_ALLOCATIONS_ASSET_ALLOCATION = 404;
export const HOME_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION = 1106;

export const EDUCATION_GENERAL_SCHOOL_TYPE = 100;
export const EDUCATION_GENERAL_SCHOOL_YEARS = 101;

export const LARGE_PURCHASE_GENERAL_PRICE_CHANGES = 200;
export const LARGE_PURCHASE_GENERAL_GOAL_YEAR = 201;
export const LARGE_PURCHASE_GENERAL_PURCHASE_FREQUENCY = 202;

export const EDUCATION_MENU = -1;
export const LARGE_PURCHASE_MENU = -2;
export const HOME_PURCHASE_MENU = -3;
export const EMERGENCY_FUND_MENU = -4;
export const HEALTHCARE_MENU = -5;
export const DEBT_MANAGEMENT_MENU = -6;
export const RETIREMENT_MENU = -8;
export const LIFE_INSURANCE_MENU = -9;
export const LONG_TERM_CARE_INSURANCE_MENU = -10;
export const DECUMULATION_MENU = -11;
export const ESTATE_PLANNING_MENU = -12;

export const ALL_PLAN_EDITS = -1000;

export const HOME_PURCHASE_GENERAL_DOWN_PAYMENT = 1100;
export const HOME_PURCHASE_GENERAL_PURCHASE_YEAR = 1101;
export const HOME_PURCHASE_GENERAL_HOME_VALUE = 1102;
export const HOME_PURCHASE_GENERAL_MORTGAGE_TYPE = 1103;
export const HOME_PURCHASE_GENERAL_MORTGAGE_INTEREST_RATE = 1104;
export const HOME_PURCHASE_ASSUMPTIONS_TAX_RATES = 1107;
export const HOME_PURCHASE_ASSUMPTIONS_PMI = 1108;
export const HOME_PURCHASE_ASSUMPTIONS_HOME_INSURANCE = 1109;
export const HOME_PURCHASE_ASSUMPTIONS_HOA = 1110;

export const HEALTH_CARE_GENERAL_PRICE = 400;
export const HEALTH_CARE_GENERAL_YEAR = 401;
export const HEALTH_CARE_GENERAL_INFLATION = 402;

export const INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES = 700;
export const INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME = 701;
export const INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE = 702;

export const INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS = 900;
export const INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST = 901;
export const INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE = 902;

export const PROFILE_CHANGES_BUSINESS_SALE = 1000;
export const PROFILE_CHANGES_REAL_ESTATE_SALE = 1001;
export const PROFILE_CHANGES_MISC_ASSET_SALE = 1002;
export const PROFILE_CHANGES_INCOME_CHANGE = 1200;

export const DECUMULATION_DISTRIBUTION_AMOUNT = 1300;
export const DECUMULATION_DISTRIBUTION_YEARS = 1301;

export const ESTATE_PLANNING_LIFE_EXPECTANCIES = 1400;
export const ESTATE_PLANNING_TAX_RATES = 1401;
export const ESTATE_PLANNING_CHARITABLE_DONATIONS = 1402;

export const ANNUITY_PURCHASE = 1500;
export const WINDFALL = 1501;

export const WHAT_IFS_GOAL_DICTIONARY = {
  retirement: RETIREMENT_MENU,
  education: EDUCATION_MENU,
  healthCare: HEALTHCARE_MENU,
  emergencyfund: EMERGENCY_FUND_MENU,
  homePurchase: HOME_PURCHASE_MENU,
  largePurchase: LARGE_PURCHASE_MENU,
  debtmanagement: DEBT_MANAGEMENT_MENU,
  [`${INSURANCE_GOAL_TYPE}.${LIFE}`]: LIFE_INSURANCE_MENU,
  [`${INSURANCE_GOAL_TYPE}.${LONG_TERM_CARE}`]: LONG_TERM_CARE_INSURANCE_MENU,
  [`${INSURANCE_GOAL_TYPE}.${ASSUMPTIONS}`]: LIFE_INSURANCE_MENU,
  decumulation: DECUMULATION_MENU,
  estatePlanning: ESTATE_PLANNING_MENU,
};

export const BASE_CLIENT_OBJECT = {
  visible: false,
  open: false,
  loading: 0,
  planImpactLoading: 0,
  errors: [],
};

export const BASE_GOAL_OBJECT = {
  currentViewId: null,
  selectedSection: '',
  whatIfsSections: {},
};

// TODO refactor more what ifs to match the insurance what ifs
export const WHAT_IFS_WITH_NO_PLAN_IMPACT = [
  INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES,
  INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME,
  INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE,
];

export const WHAT_IFS_WITH_SHELL = [
  INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES,
  INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME,
  INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE,
];

export const ADDITIONAL_SAVINGS_LABEL_DICTIONARY = {
  [DEBT_MANAGEMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'Additional Payments',
};

export const ASSET_ALLOCATION_WHAT_IFS = [
  RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_PRE,
  RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_POST,
  EDUCATION_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  LARGE_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HEALTH_CARE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HOME_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
];
